import {axios} from "./config"

export class Attendance extends axios{
   axios;
   token;
   constructor(){
   super();
   this.axios=this.axiosConfig();
 }
 async addMannual(data){
   try{
        let result=await this.axios({
        method:"post",
        url:"attendance/addMannual",
        data:data
    });
        return new Promise((res,rej)=>{
            res(result.data);
        })
        }catch(e){
            return new Promise((res,rej)=>{
                rej(e);
            })
          
        }
          }
          async getLiveAttendance(){
            try{
            let result=await this.axios({
            method:"post",
            url:"attendance/liveAttendance",
        });
            return new Promise((res,rej)=>{
                res(result.data);
            })
            }catch(e){
                return new Promise((res,rej)=>{
                    rej(e);
                })
              
            }
        }
        async getTime(){
                try{
                    let result=await this.axios({
                    method:"get",
                    url:"persondetect/getTime",
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
              }
              async setTime(data){
                try{
                    let result=await this.axios({
                    method:"post",
                    url:"persondetect/addTime",
                    data
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
              }
              async dayWiseData(date){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/dailyAttendanceReport",
                data:date
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async dayWiseDataWithPagination(date){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/dailyAttendanceReportWithPagination",
                data:date
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async combinedData(date){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/combinedData",
                data:date
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async monthWiseReport(data){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/monthWiseReport",
                data:data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async monthlyWiseData(data){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/monthlyAttendanceReport",
                data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async userWiseData(data){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/userWiseReport",
                data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async getAttendanceCameraWise(data){
                try{
                console.log(data)
                let result=await this.axios({
                method:"post",
                url:"attendance/getAttendanceCameraWise",
                data:data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            }
            async monthlyWiseDataWithPagination(data){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/monthlyAttendanceReportWithPagination",
                data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async missingPeopleList(data){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/missingPeopleList",
                data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async checkOutReports(data){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/checkOutReports",
                data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async markAttendance(data){
                try{
                let result=await this.axios({
                method:"post",
                url:"attendance/markAttendance",
                data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
            } 
            async uploadCSV(file){
                let formData=new FormData();
                formData.append("file",file)
                
                    try{
                    let result=await this.axios({
                    method:"post",
                    url:"attendance/uploadFromExcel",
                    data:formData
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
                      }
}